import { Dialog } from '../components/Dialog';
import type { GameStore } from '../../store/GameStore';
import { formatCurrency } from '../../i18n/i18n';

export function openOfficeUpgradeDialog(parent: HTMLElement, store: GameStore, onClose: () => void): void {
  const state = store.getState();
  const theme = store.getThemeData();
  const prevSpeed = state.speed;
  store.dispatch({ type: 'SET_SPEED', speed: 0 });

  const currentOffice = theme.entities.offices.find((o) => o.level === state.office.level);
  const nextOffice = theme.entities.offices.find((o) => o.level === state.office.level + 1);

  const dialog = new Dialog({
    title: 'Office Upgrade',
    onClose: () => {
      store.dispatch({ type: 'SET_SPEED', speed: prevSpeed });
      onClose();
    },
  });

  const content = document.createElement('div');
  content.style.cssText = 'display:flex;flex-direction:column;gap:12px;min-width:300px;';

  if (!nextOffice) {
    const msg = document.createElement('p');
    msg.textContent = 'You have the maximum office level!';
    msg.style.color = 'var(--color-text-secondary)';
    content.appendChild(msg);
  } else {
    // Current vs next comparison
    const compare = (label: string, current: string, next: string) => {
      const row = document.createElement('div');
      row.style.cssText = 'display:flex;justify-content:space-between;font-size:12px;padding:2px 0;';
      const l = document.createElement('span');
      l.textContent = label;
      l.style.color = 'var(--color-text-secondary)';
      const vals = document.createElement('span');
      vals.innerHTML = `${current} → <strong style="color:var(--color-success)">${next}</strong>`;
      vals.style.fontFamily = 'var(--font-pixel)';
      row.appendChild(l);
      row.appendChild(vals);
      content.appendChild(row);
    };

    const header = document.createElement('div');
    header.textContent = `${currentOffice?.name} → ${nextOffice.name}`;
    header.style.cssText = 'font-size:16px;font-weight:600;text-align:center;';
    content.appendChild(header);

    compare('Max Staff', String(currentOffice?.maxStaff ?? 0), String(nextOffice.maxStaff));
    compare('Max Teams', String(currentOffice?.maxTeams ?? 0), String(nextOffice.maxTeams));
    compare('Max Projects', String(currentOffice?.maxConcurrentProjects ?? 0), String(nextOffice.maxConcurrentProjects));
    compare('Weekly Rent', formatCurrency(currentOffice?.weeklyRent ?? 0), formatCurrency(nextOffice.weeklyRent));

    const costEl = document.createElement('div');
    costEl.style.cssText = 'text-align:center;margin-top:8px;font-size:14px;';
    const canAfford = state.company.funds >= state.office.upgradeCost;
    costEl.innerHTML = `Cost: <strong style="color:${canAfford ? 'var(--color-success)' : 'var(--color-danger)'};">${formatCurrency(state.office.upgradeCost)}</strong>`;
    content.appendChild(costEl);

    const upgradeBtn = document.createElement('button');
    upgradeBtn.className = 'btn btn--primary';
    upgradeBtn.textContent = 'Upgrade';
    upgradeBtn.disabled = !canAfford;
    upgradeBtn.style.cssText = 'padding:10px;font-size:14px;margin-top:4px;';
    upgradeBtn.addEventListener('click', () => {
      const result = store.dispatch({ type: 'UPGRADE_OFFICE' });
      if (result.success) {
        dialog.close();
      }
    });
    content.appendChild(upgradeBtn);

    if (!canAfford) {
      const hint = document.createElement('div');
      hint.textContent = `Need ${formatCurrency(state.office.upgradeCost - state.company.funds)} more.`;
      hint.style.cssText = 'text-align:center;font-size:11px;color:var(--color-danger);';
      content.appendChild(hint);
    }
  }

  dialog.body.appendChild(content);
  dialog.mount(parent);
}
